/**
 * Dispara page_view manual — necessário em SPAs Vue.js para notificar o GA4
 * (G-KE5Q1QT0KK) de mudanças de rota que não recarregam a página.
 *
 * Sem isso, todo o site aparece como uma única URL no Google Analytics,
 * inflando a taxa de rejeição e distorcendo dados de sessão.
 *
 * Chamado automaticamente via router.afterEach em src/router/index.js.
 */
export function trackPageView(pagePath, pageTitle = '') {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'page_view', {
      page_path: pagePath,
      page_title: pageTitle,
      page_location: window.location.href,
    });
  }
}
